var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useAuthProvider } from '#context';
import { usePlugFilespaceClient } from '#query-hooks';
import { GuestLinkKeyFactory } from '../query-key-factories/GuestLinkKeyFactory';
export const useGetGuestLink = ({ filespaceId, workspaceId }, linkId) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const query = useQuery({
        queryKey: GuestLinkKeyFactory.exact({
            workspaceId,
            filespaceId,
            linkId,
        }),
        // The cache type also carries the ACL entries' optimistic marks.
        queryFn: async () => plugFilespaceClient({
            action: (fsClient) => fsClient.guestLinksManagement().getGuestLink(linkId),
            filespaceId,
            workspaceId,
        }),
        enabled: Boolean(currentUser),
        retry: false,
    });
    return query;
};
_react_refresh_temp_1(useGetGuestLink, "jRMx3r7nIBDWbUBVlsDJFgWprew=", false, () => [useAuthProvider, usePlugFilespaceClient, useQuery]);
